/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartAllergiesAliases {
  ACTION_NEW = 'action-new',
  CONTEXTUAL_BAR_ALLERGIES = 'contextual-bar-allergies',
  FRAGMENT_REFERENCE_HOSPITAL = 'fragment-reference-hospital',
  FRAGMENT_REFERENCE_PATIENT = 'fragment-reference-patient',
  LAYOUT_MY_CHART_ALLERGIES = 'layout-my-chart-allergies',
  MAPPER_HOSPITAL = 'mapper-hospital',
  MAPPER_PATIENT = 'mapper-patient',
  PANEL_ALLERGIES = 'panel-allergies',
  PANEL_HOSPITAL = 'panel-hospital',
  PANEL_PATIENT = 'panel-patient',
  TAB_CONTROL_ALLERGIES = 'tab-control-allergies',
  TAB_HOSPITAL = 'tab-hospital',
  TAB_PATIENT = 'tab-patient',
}
export { MyChartAllergiesAliases };
